import { render, staticRenderFns } from "./partition.vue?vue&type=template&id=c1ffdbe6"
import script from "./partition.vue?vue&type=script&lang=js"
export * from "./partition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports